import MutateApiHookType from '@trinsly/common/src/types/mutate-api-hook-type'
import { useMutation, useQueryClient } from 'react-query'
import shareCampaignService from 'services/share-campaign-service'

type UseShareCampaignProps = {} & MutateApiHookType<Campaign>

function useShareCampaign({
  onSuccess,
  onError,
  onMutate,
}: UseShareCampaignProps) {
  const queryClient = useQueryClient()

  const { mutate: fetch, isLoading: pending } = useMutation(
    shareCampaignService,
    {
      onSuccess: async (data) => {
        await queryClient.invalidateQueries('/campaigns')
        onSuccess?.(data)
      },
      onError,
      onMutate,
    }
  )

  return {
    fetch,
    pending,
  }
}

export default useShareCampaign
